export default __webpack_public_path__ + "static/media/bot-logo-chat.bcffe1bd.svg";